import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBetHistory, fetchCasinoHistoryData } from "./cl_BetHistory.Slice";
import GameHistory from "./GameHistory";
import NewGameHistory from "./NewGameHistory";

const BetHistory = () => {

  const CurrentTabData = {
    GAME_HISTORY_TAB: "legacyHistory",
    NEW_GAME_HISTORY_TAB: "newGameHistory"
  }
  const [currentTab, setCurrentTab] = useState(CurrentTabData?.NEW_GAME_HISTORY_TAB)
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageNew, setCurrentPageNew] = useState(1);

  const { loader } = useSelector(
    (state) => state?.betHistory
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBetHistory(currentPage - 1));
  }, [currentPage]);

  useEffect(() => {
    dispatch(fetchCasinoHistoryData(currentPageNew - 1));
  }, [currentPageNew]);

  return (
    <div className="SB-page-content">
      <div className="SB-myAccountSection-container SB-betHistory">
        <div className="SB-pageHeader">
          <div className="SB-pageHeader-title">Game History</div>
        </div>
        <div className="SB-myAccountSection-filters-container" style={{ marginTop: "10px" }}>
          <div className="SB-tabs">
            <ul className="nav">
              <li>
                <button
                  type="button"
                  onClick={() => setCurrentTab(CurrentTabData.NEW_GAME_HISTORY_TAB)}
                  className={`SB-tab-item nav-link ${currentTab === CurrentTabData.NEW_GAME_HISTORY_TAB ? "active" : ""}`}
                >
                  New Game History
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => setCurrentTab(CurrentTabData.GAME_HISTORY_TAB)}
                  className={`SB-tab-item nav-link ${currentTab === CurrentTabData.GAME_HISTORY_TAB ? "active" : ""}`}
                >
                  Legacy History
                </button>
              </li>
            </ul>
          </div>
        </div>
        {loader ? (
          <div className="SB-section-loader">
            <div className="SB-section-loader-container">
              <span className="SB-dot"></span>
              <span className="SB-dot"></span>
              <span className="SB-dot"></span>
              <span className="SB-dot"></span>
            </div>
          </div>
        ) : (
          <>
            {currentTab === CurrentTabData?.NEW_GAME_HISTORY_TAB ? (
              <NewGameHistory
                currentPage={currentPageNew}
                setCurrentPage={setCurrentPageNew}
              />
            ) : (
              <GameHistory
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BetHistory;